module.exports = __webpack_public_path__ + "static/media/radioclassique.a1bd3e52.png";